<template>
	<AppDialog :min-width="640" ref="dialog_container" :dialogName="'UserSchemaMappingRespondDialog'">
		<template v-slot:header>
			<div class="flex-start--center">
				<IntegrationIcon :integrationName="service.service_slug" class="ml-2" :size="30" />
				<div class="ml-2">{{ service.service_name }} {{ fieldItem }} - {{ fieldTitle }}</div>
			</div>
		</template>
		<div class="dynamic-data-mapper-dialog px-5 py-4">
			<div class="dialog-body">
				<DynamicDataMapping
					:interfaceFieldUUID="widgetFieldUUID"
					:fieldItem="fieldItem"
					:service="service"
					@on-mapping-updated="onMappingUpdated"
					@on-params-map-updated="onParamsMapUpdated"
					@on-params-map-labels-updated="onParamsMapLabelsUpdated"
				/>
			</div>
			<div class="dialog-bottom text-align-center mt-4">
				<PrimaryButton :disabled="btnDisabled" @click="saveRespond()">Save</PrimaryButton>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { configurationsValuesByFieldUUID } from '@/store/modules/configurationEditor/getters';
import { setMappingConfigurationFieldValues } from '@/store/modules/configurationEditor/actions';

import AppDialogManagerService from '../AppDialogManager/app-dialog-manager-service';

import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import DynamicDataMapping from '@/components/BlockEditorWidget/WidgetFields/DynamicDataMapping/DynamicDataMapping';
import { getConfigurationAndInterfaceIdByFieldUUID } from '@/store/modules/selectedWorkflow/modules/configurations/getters';
import { getWidget } from '@/store/modules/widgets/getters';

const responseStructure = {
	params_map: {},
	params_map_labels: {},
	mappings: [],
	// extra_fields: { }
};

export default {
	name: 'UserSchemaMappingRespondDialog',
	props: {
		configurationInterfaceUUID: { type: String },
		widgetFieldUUID: { type: String },
		fieldItem: { type: String },
		fieldTitle: { type: String },
		service: { type: Object },
		dialogPromiseHandlers: { type: Object },
	},
	components: {
		AppDialog,
		DynamicDataMapping,
	},
	computed: {
		...mapGetters([configurationsValuesByFieldUUID.fullPath]),
		...mapGetters([getConfigurationAndInterfaceIdByFieldUUID.fullPath, getWidget.fullPath, configurationsValuesByFieldUUID.fullPath]),
		configurationAndInterfaceIdByFieldUUID() {
			return this[getConfigurationAndInterfaceIdByFieldUUID.fullPath](this.widgetFieldUUID);
		},
		interfaceUUID() {
			return this.configurationAndInterfaceIdByFieldUUID.interfaceUUID;
		},
		interface() {
			return this[getWidget.fullPath](this.interfaceUUID);
		},
		existingResponse() {
			return this[configurationsValuesByFieldUUID.fullPath][this.widgetFieldUUID] || responseStructure;
		},
		btnDisabled() {
			return (this.response?.mappings?.length || 0) < (this.fieldMapping?.length || 0);
		},
		fieldMapping() {
			return this.mappingField?.metadata?.source?.mappings || [];
		},
		mappingField() {
			return this.interface?.fields.find((x) => x.id === this.widgetFieldUUID) || {};
		},
	},
	methods: {
		...mapActions([setMappingConfigurationFieldValues.fullPath]),
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
		onMappingUpdated(value) {
			const newResponse = { ...this.response, ...{ mappings: value } };
			this.$set(this, 'response', newResponse);
		},
		onParamsMapUpdated(value) {
			const newResponse = { ...this.response, ...{ params_map: value } };

			this.$set(this, 'response', newResponse);
		},
		onParamsMapLabelsUpdated(value) {
			const newResponse = { ...this.response, ...{ params_map_labels: value } };
			this.$set(this, 'response', newResponse);
		},
		async saveRespond() {
			//store data in local cache - to save later with the other responses
			await this[setMappingConfigurationFieldValues.fullPath]({
				interfaceUUID: this.configurationInterfaceUUID,
				fieldUUID: this.widgetFieldUUID,
				fieldValue: this.response,
			});
			this.close();
		},
	},
	mounted() {
		this.response = this.existingResponse;
	},
	data() {
		return {
			response: responseStructure,
		};
	},
};
</script>

<style scoped lang="scss"></style>
